import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ControlPointIcon(props: IconProps) {
    return <Icon {...props} iconKey={"control_point"}/>
}
